export const SIGNOZ_VALUE = '#SIGNOZ_VALUE';
